import React from 'react'
import { Controller } from 'react-hook-form'
import SelectInput from './SelectInput'
import MultipleSelectInput from './MultipleSelectInput'
import TextInput from './TextInput'
import DatePickerInput from './DatePickerModal'

export default function FormField({
  label,
  type,
  name,
  required,
  disabled,
  options,
  selectedOptions,
  register,
  search,
  errors,
  control,
  placeholder,
  isTextArea,
  size,
  min,
  max,
}) {
  const renderField = () => {
    switch (type) {
      case 'select':
        return (
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <SelectInput
                label={label}
                name={name}
                options={options}
                required={required}
                error={errors[name]}
                search={search}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                disabled={disabled}
              />
            )}
          />
        )
      case 'checkbox':
        return (
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <MultipleSelectInput
                label={label}
                name={name}
                options={options}
                value={value}
                onChange={onChange}
                required={required}
                error={errors[name]}
              />
            )}
          />
        )
      case 'date':
        return (
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <DatePickerInput
                label={label}
                name={name}
                options={options}
                required={required}
                error={errors[name]}
                onChange={onChange}
                value={value}
              />
            )}
          />
        )
      default:
        return (
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <TextInput
                label={label}
                type={type}
                name={name}
                required={required}
                disabled={disabled}
                isTextArea={isTextArea}
                placeholder={placeholder}
                error={errors[name]}
                onChange={onChange}
                value={value}
                size={size}
                ref={ref}
              />
            )}
          />
        )
    }
  }

  return <div className="mb-4">{renderField()}</div>
}
